<template>
  <SPAPagination :pagination="selectedProjectMembersPagination" class="pagination" reverseOrder hideTextPerPage minimalItemRange minimalPageNumber @changePage="changePage" />
</template>
<style lang="scss" scoped>
.pagination {
  border-top: 1px solid $neutral-40;
  padding: 16px;
}
</style>
<script>
import { storeToRefs } from 'pinia';
import SPAPagination from '../../../../components/SPAPagination.vue';
import { useProjectTaggingStore } from '../../../../stores/projectTagging';

export default {
  name: 'ProjectTaggingViewProjectPagination',
  components: { SPAPagination },
  setup() {
    const projectTaggingStore = useProjectTaggingStore();
    const { selectedProject, selectedProjectMembersPagination } = storeToRefs(projectTaggingStore);
    const changePage = (page) => {
      const params = {
        ProjectID: selectedProject.value.id,
        PageNumber: page.currentPage,
        RowsPerPage: page.itemsPerPage,
      };
      projectTaggingStore.getProjectEmployees(params);
    };

    return { selectedProjectMembersPagination, changePage };
  },
};
</script>
